import Vue from 'vue'

import {
  Style,
  Button,
  Toast,
  Radio,
  Floating,
  Tag,
  Badge,
  ParaText,
  NoticeBar,
  Loading,
  LoadingB,
  Dialog,
  Input,
  Select,
  Checkbox,
  CheckboxGroup,
  LoadList,
  Switch,
  Popup,
  Form,
  FormLabel,
  Upload,
  Row,
  Col,
  Mask,
  BetterScroll,
  Textarea,
  Tab,
} from '@didi/go-design-mobile-vue'
// go-design-mobile-vue 样式
import '@didi/go-design-mobile-vue/lib/style.css'
// 全局loading
import globalLoading from '@/common/components/global-loading/index.js'

Vue.prototype.$globalLoading = globalLoading

Vue.use(Style)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Radio)
Vue.use(Floating)
Vue.use(Tag)
Vue.use(Badge)
Vue.use(ParaText)
Vue.use(NoticeBar)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Select)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(LoadList)
Vue.use(Switch)
Vue.use(Popup)
Vue.use(Form)
Vue.use(FormLabel)
Vue.use(Upload)
Vue.use(Row)
Vue.use(Col)
Vue.use(Mask)
Vue.use(Textarea)
Vue.use(LoadingB)
// Vue.use(BetterScroll)
Vue.use(Tab)
